import type { ReactNode } from 'react';

/** Shared frame for signed-out screens: sign in, reset, invitation. */
export function AuthCard({ title, lead, children }: { title: string; lead?: ReactNode; children: ReactNode }) {
  return (
    <div className="login">
      <main className="login__card">
        <img className="login__logo" src="/brand/cm9ok-logo.png" alt="CM9OK" width={1928} height={353} />
        <div>
          <h1>{title}</h1>
          {lead ? <p>{lead}</p> : null}
        </div>
        {children}
      </main>
    </div>
  );
}
